import Api from "@/services/service-v2";

export const createBusinessPlan = (payload) =>
  Api().$http.post(`/rbac/business_plan/create_business_plan`, payload);

export const subscriptionPlan = (payload) =>
  Api().$http.post(`/subscription-payments/subscription/su/filter`, payload);

export const businessPlanList = () =>
  Api().$http.get(`/rbac/business_plan/business_plan_list`);

export const businessPlanListById = (id) =>
  Api().$http.get(`/rbac/business_plan/plan_details/${id}`);

export const updateBusinessPlan = (payload) =>
  Api().$http.put(
    `/rbac/business_plan/update_business_plan/${payload.id}`,
    payload
  );

export const businessPlanDetails = (payload) =>
  Api().$http.get(
    `/rbac/business_plan/plan_details/${payload.id}`
  );

export const deleteBusinessPlan = (payload) =>
  Api().$http.delete(
    `/rbac/business_plan/delete_business_plan?id=${payload.id}`,
    payload
  );

export const featureList = () => Api().$http.get(`/rbac/feature/feature_list`);

export const featureListDetail = (payload) =>
  Api().$http.get(`/rbac/feature/feature_details?id=${payload.id}`, payload);
